import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrency } from '../../../shared/CurrencyContext';

const ContractStaff = ({ contractId, staff, readOnly = true }) => {
  const { t } = useTranslation();
  const { formatCurrency } = useCurrency();

  const calculateTotalCost = (timeWorked, rate) => {
    return timeWorked * rate;
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>{t('contracts.tabs.staff')}</h5>
        {readOnly && (
          <span className="badge bg-info-lt">{t('contracts.contractReadOnly')}</span>
        )}
      </div>

      {staff.length === 0 ? (
        <div className="text-center py-4">
          <p className="text-muted">{t('contracts.noStaff')}</p>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>{t('contracts.fields.crewMember')}</th>
                <th>{t('contracts.fields.role')}</th>
                <th>{t('contracts.fields.rateType')}</th>
                <th>{t('contracts.fields.timeWorked')}</th>
                <th>{t('contracts.fields.rate')}</th>
                <th>{t('contracts.fields.totalCost')}</th>
                <th>{t('contracts.fields.order')}</th>
              </tr>
            </thead>
            <tbody>
              {staff.map((staffMember) => (
                <tr key={staffMember.id}>
                  <td>
                    <div>
                      <strong>{staffMember.crew_member_name}</strong>
                      {staffMember.crew_member_email && (
                        <div className="text-muted small">{staffMember.crew_member_email}</div>
                      )}
                    </div>
                  </td>
                  <td>{staffMember.role}</td>
                  <td>
                    <span className={`badge ${staffMember.rate_type === 'hourly' ? 'bg-primary-lt' : 'bg-info-lt'}`}>
                      {staffMember.rate_type === 'hourly' ? t('contracts.hourly') : t('contracts.daily')}
                    </span>
                  </td>
                  <td>
                    {staffMember.time_worked} {staffMember.rate_type === 'hourly' ? t('contracts.hours') : t('contracts.days')}
                  </td>
                  <td>{formatCurrency(staffMember.rate)}</td>
                  <td>
                    <strong>{formatCurrency(calculateTotalCost(staffMember.time_worked, staffMember.rate))}</strong>
                  </td>
                  <td>{staffMember.order}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ContractStaff;
